const PROFILE_ROUTE_MAP_KEY = "karankiProfileRouteMap";

function readRouteMap() {
  try {
    return JSON.parse(sessionStorage.getItem(PROFILE_ROUTE_MAP_KEY) || "{}");
  } catch {
    return {};
  }
}

function writeRouteMap(map) {
  sessionStorage.setItem(PROFILE_ROUTE_MAP_KEY, JSON.stringify(map));
}

function hashValue(value) {
  let hash = 0;
  const text = String(value || "");
  for (let index = 0; index < text.length; index += 1) {
    hash = (hash << 5) - hash + text.charCodeAt(index);
    hash |= 0;
  }
  return Math.abs(hash).toString(36);
}

export function createProfilePath(profileOrId) {
  const realId = typeof profileOrId === "string" ? profileOrId : profileOrId?.id;
  if (!realId) return "/matches";

  const publicToken = typeof profileOrId === "object" && profileOrId?.publicProfileId
    ? profileOrId.publicProfileId
    : `profile-${hashValue(realId)}`;

  const routeMap = readRouteMap();
  routeMap[publicToken] = realId;
  writeRouteMap(routeMap);

  return `/profiles/${publicToken}`;
}

export function resolveProfileRouteId(routeId) {
  const routeMap = readRouteMap();
  return routeMap[routeId] || routeId;
}
